import { CommonUtilsService } from './../common-utils.service';
import { JsonDynamicComponentService } from './../../json-dynamic-component.service';
import { UiControlType } from './../../enums/ui-control-type.enum';
import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { concat, keys, merge } from 'lodash';
import { Config } from '../../models/ui-config';
import { FormControlValueChangedAction } from '../../models/form-value-changed-event';

@Directive()
export class ControlsBaseComponent {
  @Input() currentConfig: Config;
  @Input() parentFormGroup: FormGroup;
  @Input() form: FormGroup;
  @Output() valueChanged = new EventEmitter<any>();
  keys = keys;
  UiControlType = UiControlType;
  @Input() readOnly: boolean = false;
  getSelectedValueTitle = CommonUtilsService.getSelectedValue;

  constructor(
    protected jsonDynamicComponentService: JsonDynamicComponentService,
    protected commonUtils: CommonUtilsService,
  ) {}

  onValueChanged(values?: any[]) {
    if (this.currentConfig.uiControlType === UiControlType.Dropdown) {
      const currSelection = this.parentFormGroup?.get(
        this.currentConfig.property,
      )?.value;
      if (this.currentConfig.id) {
        this.currentConfig.fileName = this.commonUtils.getInterpolatedValue(
          this.currentConfig.id,
          merge({}, this.form.value),
        );
      }
      if (this.currentConfig?.order) {
        if (values.length > currSelection?.length) {
          const newSelection = values.filter((x) => currSelection.includes(x));
          this.parentFormGroup
            ?.get(this.currentConfig.property)
            ?.setValue(newSelection, { emitEvent: false });
        } else if (values.length < currSelection?.length) {
          const newSelection = concat(
            values,
            currSelection.filter((x) => !values.includes(x)),
          );
          this.parentFormGroup
            ?.get(this.currentConfig.property)
            ?.setValue(newSelection, { emitEvent: false });
        }
      }
    }
    if (this.currentConfig.returnTypeString) {
      const control = this.parentFormGroup.get(this.currentConfig?.property);
      control?.setValue(control.value?.toString());
    }
    this.jsonDynamicComponentService.emitFormValueChanged({
      formGroup: this.parentFormGroup,
      property: this.currentConfig.property,
      action: FormControlValueChangedAction.ValueChanged,
      config: this.currentConfig,
    });
    this.valueChanged.emit();
  }
}
